import type { Agent } from '~/core/entities/agent/Agent';
import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

import BrokerAvatarSequence from './AvatarSequence.vue';

export { default as BrokerAvatarSequence } from './AvatarSequence.vue';

export type BrokerAvatarSequenceProps = {
	class?: HTMLAttributes['class'];
	avatarClass?: HTMLAttributes['class'];
	avatarFallbackClass?: HTMLAttributes['class'];
	agents: Agent[];
};

export const avatarVariant = cva(
	'inline-flex size-full shrink-0 select-none items-center justify-center overflow-hidden rounded-full text-4xl font-normal text-primary transition-all duration-300'
);

export type AvatarVariants = VariantProps<typeof avatarVariant>;
